import { userConstants } from './constantData';

const commonDimensions = [
  'v_content_name', /* 17 */
  'v_content_type', /* 18 */
  'v_content_id', /* 19 */
  'v_genre', /* 20 */
  'v_channel_name', /* 23 */
  'v_transmission_type', /* 34 */
];

export const EPG_DATA = {
  epg_live_mini_epg: {
    page_view: {
      hash: 'p-001.076.000.000.000.000',
      event: 'pages',
      dimensions: [
        ...userConstants,
        ...commonDimensions,
      ],
    },
    filter_category: {
      hash: 'e-001.076.015.000.000.252',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        'v_list_position', /* 32 */
        'v_filter_epg', /* 56 */
        'v_filter_miniepg', /* 59 */
      ],
    },
    watch_channel: {
      hash: 'e-001.076.001.000.000.110',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        ...commonDimensions,
        'v_channel_name', /* 23 */
        'v_serie_name', /* 24 */
        'v_season', /* 25 */
        'v_list_position', /* 32 */
        'v_channel_id', /* 50 */
        'v_episode_number', /* 52 */
        'v_content_player_type', /* 53 */
        'v_episode_name', /* 55 */
        'v_is_sports', /* 66 */
        'v_content_age_rating', /* 74 */
        'v_age_restricted_content', /* 75 */
        'v_is_betting', /* 81 */
        'v_video_duration', /* 100 */
        'v_start_video_percentual', /* 104 */
      ],
    },
  },
  simplified_epg: {
    filter_category: {
      hash: 'e-036.001.015.000.000.197',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        'v_list_position', /* 32 */
        'v_tab', /* 33 */
        'v_filter_epg', /* 56 */
      ],
    },
    live_now: {
      hash: 'e-036.001.016.000.000.009',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        ...commonDimensions,
        'v_start_progress_bar', /* 22 */
        'v_channel_name', /* 23 */
        'v_serie_name', /* 24 */
        'v_season', /* 25 */
        'v_tab', /* 33 */
        'v_channel_id', /* 50 */
        'v_episode_number', /* 52 */
        'v_content_player_type', /* 53 */
        'v_episode_name', /* 55 */
        'v_is_sports', /* 66 */
        'v_content_age_rating', /* 74 */
        'v_age_restricted_content', /* 75 */
        'v_is_betting', /* 81 */
        'v_video_duration', /* 100 */
        'v_start_video_percentual', /* 104 */
      ],
    },
    next_live: {
      hash: 'e-036.001.016.000.000.097',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        ...commonDimensions,
        'v_channel_name', /* 23 */
        'v_serie_name', /* 24 */
        'v_season', /* 25 */
        'v_tab', /* 33 */
        'v_channel_id', /* 50 */
        'v_episode_number', /* 52 */
        'v_content_player_type', /* 53 */
        'v_episode_name', /* 55 */
        'v_is_sports', /* 66 */
        'v_content_age_rating', /* 74 */
        'v_age_restricted_content', /* 75 */
        'v_is_betting', /* 81 */
        'v_time_to_start', /* 106 */
      ],
    },
  },
};
